export interface RightPanelData {
  mode: RightPanelMode;
}

export enum RightPanelMode {
  Navigation = 'navigation',
  Properties = 'properties',
  Hidden = 'hidden',
}
